import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  Line,
} from "recharts";
import { Skeleton } from "@mui/material";
import { tokens } from "../../shared/clinical-design";

const tick = { fontFamily: tokens.fontMono, fontSize: 11, fill: tokens.ink3 };

const monthLabel = (m) =>
  new Date(`${m}-02T00:00:00`).toLocaleString("en-US", { month: "short" });

/**
 * MLR mensual vs meta contractual. Línea en rojo clínico (estado real: sobre
 * meta) con ReferenceLine verde punteada en el target.
 *
 * @param {Object[]} data - [{ month, mlr }]
 * @param {number} target - meta de MLR (86)
 * @param {boolean} [loading]
 */
export default function MlrTrendChart({ data = [], target = 86, loading = false }) {
  if (loading) return <Skeleton variant="rectangular" height={250} />;

  const rows = data.map((d) => ({ ...d, label: monthLabel(d.month) }));

  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid stroke={tokens.line} vertical={false} />
        <XAxis dataKey="label" tick={tick} tickLine={false} axisLine={{ stroke: tokens.lineStrong }} />
        <YAxis
          domain={[Math.min(target - 2, 84), 98]}
          tick={tick}
          width={44}
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => `${v}%`}
        />
        <Tooltip
          contentStyle={{
            fontFamily: tokens.fontUI,
            fontSize: 12,
            border: `1px solid ${tokens.line}`,
            borderRadius: 4,
          }}
          formatter={(value) => [`${value.toFixed(1)}%`, "MLR"]}
        />
        <ReferenceLine
          y={target}
          stroke={tokens.ok}
          strokeDasharray="5 3"
          label={{
            value: `Target ${target.toFixed(0)}%`,
            position: "insideBottomRight",
            fill: tokens.ok,
            fontSize: 11,
            fontFamily: tokens.fontUI,
          }}
        />
        <Line
          type="monotone"
          dataKey="mlr"
          name="MLR"
          stroke={tokens.crit}
          strokeWidth={2}
          dot={{ r: 2.5, fill: tokens.crit }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
